import * as React from 'react';
import Button from '@websky/core/src/Button';
import css from './OrderAdditionalBanner.css';
import { ArrowForward } from '@websky/core/src/Icons';
import { useTranslation } from 'react-i18next';
const OrderAdditionalBanner = props => {
    const { t } = useTranslation('Checkout');
    return (React.createElement("div", { className: css.banner },
        React.createElement("div", { className: css.text },
            React.createElement("div", { className: css.text__title }, t('Extra comfort')),
            React.createElement("div", { className: css.text__description }, t('VIP lounges, business lounges, priority pre-flight procedures')),
            React.createElement(Button, { variant: "flat", size: "small", className: css.text__button, onClick: () => window.open(props.bookingUrl, '_blank') },
                t('To book'),
                " ",
                ArrowForward)),
        React.createElement("div", { className: css.picture })));
};
export default OrderAdditionalBanner;
